import { render, staticRenderFns } from "./MedicalContentTemplatePopupInputForm.vue?vue&type=template&id=2f2c7393&scoped=true&"
import script from "./MedicalContentTemplatePopupInputForm.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplatePopupInputForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplatePopupInputForm.vue?vue&type=style&index=0&id=2f2c7393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c7393",
  null
  
)

export default component.exports